import { FunctionComponent, ComponentChild } from 'preact';
import { useRef } from 'preact/hooks';
import { Children } from 'preact/compat';
import cn from 'classnames';

import { useSentinelIntersection } from '../../hooks/useSentinelIntersection';
import { useSliderDragging } from '../../hooks/useSliderDragging';

interface SliderProps {
  header?: ComponentChild;
  onIntersection?: () => void;
  intersectionMargin?: number;
}

export const Slider: FunctionComponent<SliderProps> = ({
  children,
  header,
  onIntersection,
  intersectionMargin = 0,
}) => {
  const sentinelRef = useRef<HTMLDivElement>(null!);
  const sliderRef = useRef<HTMLUListElement>(null!);

  useSentinelIntersection({
    onIntersection,
    sentinelRef,
    rootRef: sliderRef,
    rootMargin: `0px ${intersectionMargin}px 0px 0px`,
  });

  const { handleClickCapture } = useSliderDragging({ sliderRef });

  const displayHeader = Boolean(header);

  return (
    <div
      className={cn('vgp-slider', { 'vgp-slider-no-header': !displayHeader })}
    >
      {displayHeader && <div className="vgp-slider-header">{header}</div>}
      <ul
        className="vgp-slider-list"
        ref={sliderRef}
        onClickCapture={handleClickCapture}
      >
        {Children.toArray(children).map((item, index) => (
          <li key={index} className="vgp-slider-item">
            {item}
          </li>
        ))}
        <div ref={sentinelRef} />
      </ul>
    </div>
  );
};
